export default function Button({
  children,
  type = "button",
  variant = "base",
  size = "md",
  disabled = false,
  onClick,
  className = ""
}) {
  const base =
    "inline-flex items-center justify-center font-semibold tracking-wide rounded-xl transition-all duration-200 ease-out focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";

  const variants = {
    primary: `
      bg-primary text-white
      border-t border-gold/40
      hover:bg-primary/95
      focus:ring-gold
    `,

    secondary: `
      bg-surface text-text border border-muted
      hover:bg-muted/10
      focus:ring-primary
    `,

    ghost: `
      bg-transparent text-primary
      hover:bg-primary/10
      focus:ring-primary
    `,

    gold: `
      bg-gold text-primary
      hover:bg-gold/90
      shadow-sm
      focus:ring-gold
    `,

    danger: `
      bg-transparent
      border border-danger
      text-danger
      hover:bg-danger hover:text-white
      focus:ring-danger
    `,

    danger_soft: `
      bg-[#F3E5E5]
      text-[#7A1F1F]
      hover:bg-[#EBD3D3]
      focus:ring-[#7A1F1F]
    `,

    danger_outline: `
      bg-transparent border border-red-600 text-red-600
      hover:bg-red-600 hover:text-white
      focus:ring-red-600
    `,

    danger_ghost: `
      bg-transparent text-red-600
      hover:bg-red-600/10
      focus:ring-red-600
    `
  };

  const sizes = {
    sm: "h-9 px-4 text-sm",
    md: "h-11 px-5 text-sm",
    lg: "h-12 px-6 text-base"
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={[base, variants[variant], sizes[size], className].join(" ")}
    >
      {children}
    </button>
  );
}
